import mntAuditTrail from "./mntAuditTrail";
import mntUsers from "./mntUsers";

const mntChild = [
    mntUsers,
    mntAuditTrail
];

export default mntChild;